import { render, staticRenderFns } from "./deleteLabel.vue?vue&type=template&id=13baba62"
import script from "./deleteLabel.vue?vue&type=script&lang=js"
export * from "./deleteLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports